import React from 'react';
export function BonusSection() {
  return <section className="py-6 px-4 bg-gradient-to-b from-yellow-50 to-white" data-id="element-85">
      <div className="max-w-4xl mx-auto" data-id="element-86">
        <h2 className="text-3xl md:text-5xl font-black text-center mb-2" data-id="element-87">
          🎁 Y ADEMÁS TE LLEVAS GRATIS:
        </h2>
        <p className="text-2xl font-bold text-red-600 text-center mb-6" data-id="element-88">
          ¡GRATIS POR EL DÍA DE HOY!
        </p>

        <div className="grid md:grid-cols-3 gap-4 mb-6" data-id="element-89">
          <a href="#compra" className="block hover:scale-105 transition-transform duration-300" data-id="element-90">
            <img src="https://cdn.magicpatterns.com/uploads/fs9NUoVgHwHkCwjbsFpt9T/mockup_bono1.png" alt="Bono 1 - 50 Juegos Financieros" className="w-full aspect-square object-cover rounded-lg shadow-lg cursor-pointer" data-id="element-91" />
            <div className="mt-2 text-center" data-id="element-92">
              <h3 className="text-xl font-black mb-1" data-id="element-93">
                🎲 BONO 1: 50 Juegos Financieros
              </h3>
              <p className="text-lg" data-id="element-94">Para aprender jugando</p>
            </div>
          </a>

          <a href="#compra" className="block hover:scale-105 transition-transform duration-300" data-id="element-95">
            <img src="https://cdn.magicpatterns.com/uploads/nJTkSAEn3iWBWtgBt3gfz2/mockup_bono2.png" alt="Bono 2 - Guía para padres sin tiempo" className="w-full aspect-square object-cover rounded-lg shadow-lg cursor-pointer" data-id="element-96" />
            <div className="mt-2 text-center" data-id="element-97">
              <h3 className="text-xl font-black mb-1" data-id="element-98">
                ⏱️ BONO 2: Guía para padres sin tiempo
              </h3>
              <p className="text-lg" data-id="element-99">Solo 10 minutos al día</p>
            </div>
          </a>

          <a href="#compra" className="block hover:scale-105 transition-transform duration-300" data-id="element-100">
            <img src="https://cdn.magicpatterns.com/uploads/4peSs4xABrtE4iKGT8eg5m/mockup_bono3.png" alt="Bono 3 - Plantillas listas para usar" className="w-full aspect-square object-cover rounded-lg shadow-lg cursor-pointer" data-id="element-101" />
            <div className="mt-2 text-center" data-id="element-102">
              <h3 className="text-xl font-black mb-1" data-id="element-103">
                📊 BONO 3: Plantillas listas para usar
              </h3>
              <p className="text-lg" data-id="element-104">Sistema práctico inmediato</p>
            </div>
          </a>
        </div>
      </div>
    </section>;
}
export default BonusSection;